// extracted by mini-css-extract-plugin
export default {"root":"kGkjr","flames":"_2qPDm","flame":"_38bMw"};